import { DialogTitle } from '@aibees/shared/components';
import { useCurrentSubscriptionApi } from '@aibees/shared/features/price-and-plan/api/use-current-subscription-api';
import { useBoolean } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { DialogContent, Stack } from '@mui/material';
import { memo, useEffect } from 'react';
import { CreditEffect } from '../credit-effect';
import { DowngradeEffect } from '../downgrade-effect';
import { DialogFooter } from './components/dialog-footer';
import { ImportantNote } from './components/important-note';
import { StatusCard } from './components/status-card';
import * as Styled from './styles';
import * as SX from './sx';
import type { SubscriptionScheduledDialogProps as Props } from './types';

export const SubscriptionScheduledDialog = memo(
  ({ className, activeModal, closeModal, onCancel, onConfirm }: Props) => {
    const state = useBoolean(false);

    useEffect(() => {
      state.setValue(window.location.hash.includes('#successFreeDowngrade'));
    }, [activeModal, state, window.location.hash]);

    const { data } = useCurrentSubscriptionApi();

    const handleCloseModal = () => {
      window.location.hash = '';
      state.setValue(false);
      closeModal();
    };

    return (
      <Styled.Wrapper
        open={state.value}
        onClose={closeModal}
        className={classnames('SubscriptionScheduledDialog', className)}
        sx={SX.root}
      >
        <DialogTitle
          title="Downgrade to Free Plan Scheduled"
          onClose={handleCloseModal}
        />
        <DialogContent>
          <Stack gap={1}>
            <StatusCard />
            <Stack sx={SX.content} gap={1}>
              <CreditEffect
                creditAmount={Number(data?.next?.plan?.metadata.request)}
                label="Free Plan Credits /Monthly"
              />
              <CreditEffect
                creditAmount={Number(data?.next?.plan?.metadata.rollover)}
                label="Free Plan Roll over Credit Cap"
              />
              <CreditEffect
                creditAmount={Number(data?.current?.plan?.metadata.request)}
                label="Current Credit Plan"
              />
              <DowngradeEffect />
              <ImportantNote />
            </Stack>
          </Stack>
        </DialogContent>
        <DialogFooter
          closeModal={closeModal}
          onCancel={onCancel}
          onConfirm={onConfirm}
        />
      </Styled.Wrapper>
    );
  }
);

SubscriptionScheduledDialog.displayName = 'SubscriptionScheduledDialog';
